var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('span',{staticClass:"spinner",class:{ 'spinner--small': _vm.isSmall }},[_c('object',{staticStyle:{"width":"230px","height":"230px"},attrs:{"data":"/img/Grexy_loader-2.svg"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }